import { Component } from '@angular/core';

@Component({
  selector: 'app-navbar',
  templateUrl: 'cabecera.component.html'
})

export class cabecera {

}



// WEBPACK FOOTER //
// /Users/usuario/Desktop/Angular/Urbanos/src/app/components/cabecera.component.ts